import { MalwareFilterPolicy } from 'projects/angular-clarity/src/app/interfaces/powershell/exo/malware-filter-policy.interface';
import { updateExoMalwareFilterPolicy } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/malware-filter-policy/actions';

export const Identity = 'Default';

export function Remediate(_tenant: string, data: MalwareFilterPolicy[], schema: any) {
    const defaultPolicy = data.find((res) => res.IsDefault);
    return updateExoMalwareFilterPolicy({
        _tenant,
        data: {
            Identity: defaultPolicy?.Identity || Identity,
            EnableFileFilter: schema.contains.properties.EnableFileFilter.const,
            ZapEnabled: schema.contains.properties.ZapEnabled.const,
            FileTypes: schema.contains.properties.FileTypes?.items?.enum,
            FileTypeAction: schema.contains.properties.FileTypeAction?.const,
            QuarantineTag: schema.contains.properties.QuarantineTag?.const || null,
            EnableInternalSenderAdminNotifications:
                schema.contains.properties.EnableInternalSenderAdminNotifications.const,
            InternalSenderAdminAddress: schema?.contains?.properties?.InternalSenderAdminAddress?.const || null,
            EnableExternalSenderAdminNotifications:
                schema.contains.properties.EnableExternalSenderAdminNotifications.const,
            ExternalSenderAdminAddress: schema?.contains?.properties?.ExternalSenderAdminAddress?.const || null,
            CustomNotifications: schema?.contains?.properties?.CustomNotifications?.const ?? null,
            CustomFromName: schema?.contains?.properties?.CustomFromName?.const || null,
            CustomFromAddress: schema?.contains?.properties?.CustomFromAddress?.const || null,
            CustomInternalSubject:
                schema.contains.properties.EnableInternalSenderAdminNotifications.const &&
                schema.contains.properties.CustomNotifications.const
                    ? schema?.contains?.properties?.CustomInternalSubject?.const || null
                    : null,
            CustomInternalBody:
                schema.contains.properties.EnableInternalSenderAdminNotifications.const &&
                schema.contains.properties.CustomNotifications.const
                    ? schema?.contains?.properties?.CustomInternalBody?.const || null
                    : null,
            CustomExternalSubject:
                schema.contains.properties.EnableExternalSenderAdminNotifications.const &&
                schema.contains.properties.CustomNotifications.const
                    ? schema?.contains?.properties?.CustomExternalSubject?.const || null
                    : null,
            CustomExternalBody:
                schema.contains.properties.EnableExternalSenderAdminNotifications.const &&
                schema.contains.properties.CustomNotifications.const
                    ? schema?.contains?.properties?.CustomExternalBody?.const || null
                    : null,
        },
    });
}
